function nvPlayVideo(video) {
  video.muted = true;
  video.setAttribute('muted', '');
  video.playsInline = true;
  var playPromise = video.play();
  if (playPromise && playPromise.catch) playPromise.catch(function () {});
}

function nvAutoplayVideos() {
  var elements = document.querySelectorAll('deferred-media[data-autoplay-video="true"]');

  elements.forEach(function (el) {
    if (typeof el.loadContent === 'function') el.loadContent(false);
  });

  window.setTimeout(function () {
    elements.forEach(function (el) {
      var video = el.querySelector('video');
      if (video) nvPlayVideo(video);
    });
  }, 50);
}

nvAutoplayVideos();
document.addEventListener('DOMContentLoaded', nvAutoplayVideos);
window.addEventListener('load', nvAutoplayVideos);
document.addEventListener('visibilitychange', function () {
  if (!document.hidden) nvAutoplayVideos();
});
